import { render } from "./edit_house.vue?vue&type=template&id=cb2b03f2"
import script from "./edit_house.vue?vue&type=script&lang=js"
export * from "./edit_house.vue?vue&type=script&lang=js"

import "./edit_house.vue?vue&type=style&index=0&id=cb2b03f2&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__